module.exports = __webpack_public_path__ + "static/media/coupe6.9479a346.jpg";